import React from "react";
import formatNumber, { convertNumberToWordsInFCFA, formatDateWithTime, getOrderLineWarehouseCode } from "../../../utils/functions";
import { lineTotalForBrokenTileItem } from "../../../utils/broken-tile-sale";
import { APP_NAME } from "../../../utils";
import { QRCodeCanvas } from "qrcode.react";

export default function Invoice({ data, isCopy = true }) {

  return (
    <div className={`${isCopy ? 'invoice-copy second-copy' : 'invoice-copy'} relative`}>
      {/* <img src="/assets/img/logo.png" className="absolute rotate-45 z-0" alt={APP_NAME} /> */}
      <div className="flex flex-row justify-between items-start mt-10">
        <div className="">
          <img src="/assets/img/logo_v2.png" height={100} width={100} alt={APP_NAME} />

          {/* <p className="mt-3 font-medium text-sm tracking-widest">
            ASEBat
          </p> */}
          <p className="font-medium text-sm mt-3">C/1775 C, QUARTIER GBEDJEKOME - OUEDO</p>
          {/* <p className="font-medium text-sm">BP 952 ABOMEY - CALAVI, BENIN</p> */}
          <p className="font-medium text-sm">IFU 3202434985932</p>
          {/* <p className="font-medium text-sm">NIM: TS01013080</p> */}
          <p className="font-medium text-sm">info@asebat.com</p>
          <p className="font-medium text-sm">+229 01 61 89 89 00</p>
        </div>

        {data.statut_commande !== "canceled" && data.emecef_data && JSON.parse(data.emecef_data).codeMECeFDGI && (() => {
          try {
            const parsedData = JSON.parse(data.emecef_data);
            const decodedData = typeof parsedData === 'string' ? JSON.parse(parsedData) : parsedData;

            if (!decodedData.errors) {
              return (
                <div className="">
                  <p className="mb-0 font-semibold text-[10px]">
                    ELÉMENTS DE SÉCURITÉ DE LA FACTURE NORMALISÉE ­­­
                  </p>
                  <table className="border-collapse w-full text-sm whitespace-pre table-auto">
                    <tbody className="">
                      <tr>
                        <td className="p-1 border font-medium text-sm" rowSpan={4}>
                          <div className="flex flex-row justify-center items-center p-1">
                            <QRCodeCanvas
                              value={decodedData.qrCode}
                              size={80} // Taille du QR code en pixels
                              bgColor={"#ffffff"} // Couleur de fond
                              fgColor={"#000000"} // Couleur du QR code
                              level={"L"} // Niveau de correction d'erreur (L, M, Q, H)
                            />
                          </div>
                        </td>
                        <td className="p-1 border font-medium text-[10px]">Code MECeF/DGI:</td>
                        <td className="p-1 border font-medium text-[10px]">{decodedData.codeMECeFDGI}</td>
                      </tr>
                      <tr>
                        <td className="p-1 border font-medium text-[10px]">MECeF NIM:</td>
                        <td className="p-1 border font-medium text-[10px]">{decodedData.nim}</td>
                      </tr>
                      <tr>
                        <td className="p-1 border font-medium text-[10px]">MECeF Compteurs:</td>
                        <td className="p-1 border font-medium text-[10px]">{decodedData.counters}</td>
                      </tr>
                      <tr>
                        <td className="p-1 border font-medium text-[10px]">MECeF Heure:</td>
                        <td className="p-1 border font-medium text-[10px]">{decodedData.dateTime}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              );
            } else {
              // Afficher uniquement si des erreurs existent
              return null;
            }
          } catch (error) {
            console.error("Erreur lors de l'analyse JSON:", error);
            return null;
          }
        })()}

        {data.statut_commande === "canceled" && data.emecef_data_cancel && JSON.parse(data.emecef_data_cancel).data && (() => {
          try {
            const parsedData = JSON.parse(data.emecef_data_cancel);
            const decodedData = typeof parsedData === 'string' ? JSON.parse(parsedData) : parsedData;

            if (!decodedData.errors) {
              return (
                <div className="">
                  <p className="mb-0 font-semibold text-[10px]">
                    ELÉMENTS DE SÉCURITÉ DE LA FACTURE NORMALISÉE ­­­
                  </p>
                  <table className="border-collapse w-full text-sm whitespace-pre table-auto">
                    <tbody className="">
                      <tr>
                        <td className="p-1 border font-medium text-sm" rowSpan={4}>
                          <div className="flex flex-row justify-center items-center p-1">
                            <QRCodeCanvas
                              value={decodedData.data.qrCode}
                              size={80} // Taille du QR code en pixels
                              bgColor={"#ffffff"} // Couleur de fond
                              fgColor={"#000000"} // Couleur du QR code
                              level={"L"} // Niveau de correction d'erreur (L, M, Q, H)
                            />
                          </div>
                        </td>
                        <td className="p-1 border font-medium text-[10px]">Code MECeF/DGI:</td>
                        <td className="p-1 border font-medium text-[10px]">{decodedData.data.codeMECeFDGI}</td>
                      </tr>
                      <tr>
                        <td className="p-1 border font-medium text-[10px]">MECeF NIM:</td>
                        <td className="p-1 border font-medium text-[10px]">{decodedData.data.nim}</td>
                      </tr>
                      <tr>
                        <td className="p-1 border font-medium text-[10px]">MECeF Compteurs:</td>
                        <td className="p-1 border font-medium text-[10px]">{decodedData.data.counters}</td>
                      </tr>
                      <tr>
                        <td className="p-1 border font-medium text-[10px]">MECeF Heure:</td>
                        <td className="p-1 border font-medium text-[10px]">{decodedData.data.dateTime}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              );
            } else {
              // Afficher uniquement si des erreurs existent
              return null;
            }
          } catch (error) {
            console.error("Erreur lors de l'analyse JSON:", error);
            return null;
          }
        })()}
      </div>

      <div className="flex flex-row justify-between items-start mt-2">
        <div>
          <p className="font-medium text-sm">
            <span className="font-semibold">Code et Nom Agent</span> : {data?.user ? `${String(data.user.id).padStart(3, '0')} - ${data.user.name}` : "Non spécifié"}
          </p>
          <p className="font-medium text-sm">
            <span className="font-semibold">Magasin</span> : {data.store?.name || data.magasin?.name || "Non spécifié"}
          </p>
          <p className="font-medium text-sm">
            <span className="font-semibold">Date</span> : {formatDateWithTime(data?.created_at)}
          </p>
        </div>
      </div>

      <p className="text-right mt-2 font-medium text-xl">
        <span className="font-bold uppercase">
          {data.status === "canceled"
            ? "Facture d'avoir"
            : "Facture de vente"
          }
        </span> :
        ASB-{new Date(data.created_at).getTime()}{data?.items?.length}
      </p>


      {(() => {
        try {
          const parsed = data?.emecef_data && JSON.parse(data.emecef_data);
          return parsed?.codeMECeFDGI && !parsed?.errors && data.statut_commande === "canceled" ? (
            <p className="text-right font-medium text-sm">
              <span className="font-bold">Référence de la facture originale</span><br />
              {parsed.codeMECeFDGI}
            </p>
          ) : null;
        } catch (e) {
          console.error("Erreur lors du parsing :", e);
          return null;
        }
      })()}


      <div className="overflow-x-auto">
        <table className="border-collapse mt-3 w-full text-sm whitespace-pre table-auto">
          <thead>
            <tr className="">
              <th className="p-2 border font-semibold pe-7">Code client</th>
              <th className="p-2 border font-semibold text-start">Client</th>
              <th className="p-2 border font-semibold">IFU</th>
              <th className="p-2 border font-semibold">Téléphone</th>
            </tr>
          </thead>
          <tbody className="">
            <tr>
              <td className="p-2 border font-medium">{data?.customer?.client_code || "-"}</td>
              <td className="p-2 border font-medium">{data?.customer?.name || "-"}</td>
              <td className="p-2 border font-medium">{data?.customer?.ifu || "-"}</td>
              <td className="p-2 border font-medium">{data?.customer?.numero || "-"}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div className="overflow-x-auto">
        <table className="border-collapse w-full text-sm whitespace-pre table-auto">
          <thead>
            <tr className="">
              <th className="p-2 border font-semibold text-sm">
                Magasin
              </th>
              <th className="p-2 border font-semibold text-sm">
                Produit
              </th>
              <th className="p-2 border font-semibold text-sm">
                Prix Unitaire
              </th>
              <th className="p-2 border font-semibold text-sm pe-7">
                Qté (sacs / m²)
              </th>
              <th className="p-2 border font-semibold text-sm">
                Prix Total
              </th>
            </tr>
          </thead>
          <tbody className="">
            {data?.items?.length > 0 ? (
              data.items.map((item, index) => (
                <tr key={index}>
                  <td className="p-2 border font-medium text-sm">
                    {getOrderLineWarehouseCode(item)}
                  </td>
                  <td className="p-2 border font-medium text-sm">
                    Carreaux casses sac de {item.format} m²
                  </td>
                  <td className="p-2 border font-medium text-sm">
                    {formatNumber(item.unit_price)} FCFA/m²
                  </td>
                  <td className="p-2 border font-medium text-sm">
                    {item.quantity} sac{item.quantity > 1 ? 's' : ''}
                    {item.m2 != null ? ` (${formatNumber(item.m2)} m²)` : ''}
                  </td>
                  <td className="p-2 border font-medium text-sm">
                    {formatNumber(lineTotalForBrokenTileItem(item))} FCFA
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="4" className="p-2 font-medium text-center text-sm">
                  Aucun produit dans le panier.
                </td>
              </tr>
            )}
            <tr>
              <td colSpan={4} className="p-2 border font-semibold text-sm">
                Commentaires
              </td>
              <td colSpan={2} className="p-2 border font-semibold text-end text-sm">
                <b>Sous-total lignes :</b>{' '}
                {formatNumber(
                  (data.items || []).reduce((sum, item) => sum + lineTotalForBrokenTileItem(item), 0)
                )}{' '}
                FCFA
              </td>
            </tr>
            <tr>
              <td
                colSpan={4}
                rowSpan={4}
                className="border-e-0 p-2 border font-medium text-sm"
              >
                Les marchandises vendues ne sont ni reprises ni échangées. <br />La disponibilité de votre achat n'est plus garantie 14 jours <br />après la date de facturation.
              </td>
              <td className="p-2 border font-semibold text-end text-sm">
                <b>Montant HT :</b> {formatNumber(data.montant_ht)} FCFA
              </td>
            </tr>
            {data.tva > 0 &&
              <tr>
                <td colSpan={5} className="p-2 border font-semibold text-end text-sm">
                  {/* Montant de la TVA en espèces */}
                  <b>T.V.A (18%) :</b> {formatNumber(data.tva)} FCFA
                </td>
              </tr>
            }
            {data.aib_value &&
              <tr>
                <td colSpan={5} className="p-2 border font-semibold text-end text-sm">
                  {/* Montant de la TVA en espèces */}
                  <b>AIB (0{`${(data.aib_value === 'A' ? 1 : data.aib_value === 'B' ? 5 : '')}`}%) :</b> {formatNumber(data.aib)} FCFA
                </td>
              </tr>
            }
            {(data.remise > 0 || data.discount > 0) && (
              <tr>
                <td colSpan={5} className="p-2 border font-semibold text-end text-sm">
                  <b>Remise :</b> −{formatNumber(data.remise ?? data.discount)} FCFA
                </td>
              </tr>
            )}
            <tr>
              <td colSpan={5} className="p-2 border font-semibold text-end text-sm">
                <b>NET :</b> {formatNumber(data.montant_net)} FCFA
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div className="flex flex-wrap justify-between items-center gap-6 mt-3">
        <div>
          <p className="font-medium text-sm capitalize">
            <span className="font-bold">Montant en lettre</span> : {convertNumberToWordsInFCFA(Math.round(data?.montant_net))}
          </p>

          {/* <p className="font-medium text-sm">
            <span className="font-bold">Mode de règlement</span> : {data?.mode_reglement?.nom || "Non spécifié"}
          </p>
          <p className="font-medium text-sm">
            <span className="font-bold">Référence de la pièce</span> : {data?.reference_piece || "Non spécifiée"}
          </p> */}
        </div>
      </div>
    </div>
  );
}